module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.3bb85fb6.jpg";